var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSrMicrophoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2107_26945)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2107_26945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1565 6.09375C12.1565 6.025 12.1002 5.96875 12.0315 5.96875H11.094C11.0252 5.96875 10.969 6.025 10.969 6.09375C10.969 8.28594 9.19243 10.0625 7.00024 10.0625C4.80806 10.0625 3.03149 8.28594 3.03149 6.09375C3.03149 6.025 2.97524 5.96875 2.90649 5.96875H1.96899C1.90024 5.96875 1.84399 6.025 1.84399 6.09375C1.84399 8.72969 3.82212 10.9047 6.37524 11.2125V12.8125H4.10493C3.89087 12.8125 3.71899 13.0359 3.71899 13.3125V13.875C3.71899 13.9438 3.76274 14 3.81587 14H10.1846C10.2377 14 10.2815 13.9438 10.2815 13.875V13.3125C10.2815 13.0359 10.1096 12.8125 9.89556 12.8125H7.56274V11.2203C10.1456 10.9391 12.1565 8.75156 12.1565 6.09375ZM7.00024 8.75C8.46743 8.75 9.65649 7.575 9.65649 6.125V2.625C9.65649 1.175 8.46743 0 7.00024 0C5.53306 0 4.34399 1.175 4.34399 2.625V6.125C4.34399 7.575 5.53306 8.75 7.00024 8.75ZM5.53149 2.625C5.53149 1.83438 6.18618 1.1875 7.00024 1.1875C7.81431 1.1875 8.46899 1.83438 8.46899 2.625V6.125C8.46899 6.91563 7.81431 7.5625 7.00024 7.5625C6.18618 7.5625 5.53149 6.91563 5.53149 6.125V2.625Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2107_26945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2107_26945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrMicrophoneIcon);
export default __webpack_public_path__ + "static/media/sr-microphone-icon.1af671831c2d190763521d08a52351c8.svg";
export { ForwardRef as ReactComponent };